import {Injectable} from '@angular/core';
import { MetricApi } from '../api/metric.api';

@Injectable()
export class MetricService {
    constructor(private metricApi: MetricApi) { }

    getUserGrowthExcel = () => this.metricApi.getUserGrowthExcel()
}